import React, { createContext, useContext } from 'react';
import { useSubscriptionOffersQuery } from '@/hooks/GQL';
import { selectFreeTrialPlusSubscription } from '@/selectors';

const SubscriptionsContext = createContext({});

export const SubscriptionsProvider = ({ children }) => {
  const { data, loading } = useSubscriptionOffersQuery();

  return (
    <SubscriptionsContext.Provider value={{ data, loading }}>
      {children}
    </SubscriptionsContext.Provider>
  );
};

const useSubscriptionsContext = () => {
  return useContext(SubscriptionsContext);
};

export const useIsSubscriptionOffersLoading = () => {
  return useSubscriptionsContext().loading;
};

export const useSubscriptionOffers = () => {
  return useSubscriptionsContext().data?.subscriptionOffers;
};

export const useFreeTrialPlusOffer = () => {
  return selectFreeTrialPlusSubscription(useSubscriptionOffers());
};

export const useFreeTrialPlusOfferSelector = (selector) => {
  return selector(useFreeTrialPlusOffer());
};
